import React from "react"
import withStyles from "@material-ui/core/styles/withStyles"
import PropTypes from "prop-types"
import { currentCompany, publicUrl } from "../../../constants"

const alt = "Sanofi"
const src = `${publicUrl}/images/${currentCompany}/logo.jpg`

const styles = theme => ({
    logo: {
        width: 409,
        [theme.breakpoints.down("sm")]: {
            width: 285,
        },
    },
})

const Sanofi = ({ classes, ...props }) => (
    <img
        {...props}
        className={classes.logo}
        alt={alt}
        src={src}
    />
)

Sanofi.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Sanofi)
